export const load = () => ({
	title: 'Care Guide',
	showTitle: true,
});
